import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons';
import { ShipmentLocationActionRequestDtoLocationActionType as LocationActionType } from '@uturn/api/v1';
import {
	Button,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuTrigger,
	Icon,
} from '@uturn/ui-kit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function AddShipmentLocationDropdown({
	label,
	insert,
}: {
	label: string;
	insert: (locationActionType: LocationActionType) => void;
}) {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	return (
		<DropdownMenu open={open} onOpenChange={setOpen}>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="sm">
					<span className="flex items-center text-sm font-medium">
						<Icon icon={faPlusCircle} className="mr-2 size-5" />
						{label}
					</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="start" className="w-[200px]">
				<DropdownMenuGroup>
					<DropdownMenuItem onSelect={() => insert(LocationActionType.DELIVER)}>
						{t(
							'pages.shipment-details.add-shipment-location.options.deliver',
							'Deliver',
						)}
					</DropdownMenuItem>
					<DropdownMenuItem onSelect={() => insert(LocationActionType.LOAD)}>
						{t(
							'pages.shipment-details.add-shipment-location.options.load',
							'Load',
						)}
					</DropdownMenuItem>
					<DropdownMenuItem onSelect={() => insert(LocationActionType.STOP)}>
						{t(
							'pages.shipment-details.add-shipment-location.options.stop',
							'Stop',
						)}
					</DropdownMenuItem>
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}

export function AddShipmentLocation({
	insert,
}: {
	insert: (locationActionType: LocationActionType) => void;
}) {
	const { t } = useTranslation();

	// Always offer Deliver / Load / Stop regardless of the current transport
	// type. The type is derived from the route, so adding a Deliver/Load must be
	// able to turn a shunt into an import/export (and removing it reverts to a
	// shunt) — see the badge derivation in route-section.tsx.
	return (
		<div className="relative flex w-full items-center justify-center pt-6">
			<AddShipmentLocationDropdown
				label={t(
					'pages.shipment-details.add-shipment-location.button',
					'Add extra location or stop',
				)}
				insert={insert}
			/>
		</div>
	);
}
